import { A } from '@solidjs/router'
import { Component, Show } from 'solid-js'
import preventCursorSelectText from '../../lib/dom/event/preventCursorSelectText'
import preventDefault from '../../lib/dom/event/preventDefault'
import stopImmediatePropagation from '../../lib/dom/event/stopImmediatePropagation'
import createCornerWidgetEngineSignal from '../../rx/shared/CornerWidget/createCornerWidgetEngineSignal'
import { getModalMenu, setModalMenu } from '../../rx/shared/ModalMenu/ModalMenuSignal'
import { getAuthProfile } from '../../rx/shared/profile/createAuthProfileSignal'
import EngineContext from '../EngineContext'
import GameActionLogListModal from '../GameActionLogListModal'
import GamePlayersListModal from '../GamePlayersListModal'
import BreakpointCardWidget from '../Hud/BreakpointCardWidget'
import ModalMenuMain from '../ModalMenu/ModalMenuMain'
import ShowAvatar from '../ShowAvatar'
import DraftMoveMenuWidget from './DraftMoveMenuWidget'
import FactoryStoreCornerWidget from './FactoryStoreCornerWidget'
import OtherTurnPlayerCornerWidget from './OtherTurnPlayerCornerWidget'
import PlayerCornerWidget from './PlayerCornerWidget'
import TopLeftEngineToolCornerWidget from './TopLeftEngineToolCornerWidget'
import YourTurnModalCornerWidget from './YourTurnModalCornerWidget'

const TheCornerWidget: Component = () => {
  const handleClickToggleIsMenuOpen = (event: Event) => {
    setModalMenu(getModalMenu() ? null : ModalMenuMain)
    preventDefault(event)
  }
  // const closeMenu = () => setIsMenuOpen(false)

  // useBeforeLeave(closeMenu)

  const [getEngine] = createCornerWidgetEngineSignal()

  return <div
    ref={(elem) => {
      preventCursorSelectText(elem)
    }}
    class="cwr"
    onWheel={stopImmediatePropagation}
    onMouseUp={stopImmediatePropagation}
    onMouseDown={stopImmediatePropagation}
    onClick={stopImmediatePropagation}
    onContextMenu={stopImmediatePropagation}
    onMouseMove={stopImmediatePropagation}
  >
    <div class="cwrs">
      <div class="cw-row">
        <Show when={getEngine()}>{(engine) => <>
          <EngineContext.Provider value={engine()}>
            <FactoryStoreCornerWidget />
            <OtherTurnPlayerCornerWidget />
            <DraftMoveMenuWidget />
            <GamePlayersListModal />
            <GameActionLogListModal />
            <BreakpointCardWidget />
          </EngineContext.Provider>
        </>}</Show>
      </div>
    </div>
    <div class="cwre">
      <div class="cw-row">
        <A href="/auth/profile"
          class="cw-pp"
          onClick={handleClickToggleIsMenuOpen}
        >
          <ShowAvatar
            profile={getAuthProfile()}
            size={80}
          // loading={profile}
          />
        </A>
        <Show when={getEngine()}
          children={(engine) => <EngineContext.Provider value={engine()}>
            <YourTurnModalCornerWidget />
            <PlayerCornerWidget />
          </EngineContext.Provider>
          } />
      </div>
      <div class="cw-row">
        <Show when={getEngine()}
          children={(engine) => <EngineContext.Provider value={engine()}>
            <TopLeftEngineToolCornerWidget />
          </EngineContext.Provider>
          } />
      </div>
    </div>
  </div>
}

export default TheCornerWidget
